import { z } from 'zod';
import { instantSchema, nonEmptyTextSchema, uuidSchema } from './primitives.js';
import { revisionMetadataSchema } from './versioning.js';
export const vehicleSchema = z.strictObject({
    vehicle_id: uuidSchema,
    series: nonEmptyTextSchema,
    full_number: z.string().min(1).max(64).nullable(),
    nickname: z.string().min(1).max(128).nullable(),
    operator: z.string().min(1).max(256).nullable(),
    vehicle_type: z.enum(['locomotive', 'multiple_unit', 'driving_trailer', 'railcar', 'other']),
    favorite: z.boolean(),
    last_used_at: instantSchema.nullable(),
    lifecycle: z.enum(['active', 'archived']),
    metadata: revisionMetadataSchema,
});
export const vehicleSnapshotSchema = z.strictObject({
    vehicle_id: uuidSchema,
    series: nonEmptyTextSchema,
    full_number: z.string().min(1).max(64).nullable(),
    nickname: z.string().min(1).max(128).nullable(),
    operator: z.string().min(1).max(256).nullable(),
    vehicle_type: z.enum(['locomotive', 'multiple_unit', 'driving_trailer', 'railcar', 'other']),
});
//# sourceMappingURL=vehicle.js.map